import React, { useState, useEffect } from 'react';
import { 
    MDBModal,
    MDBRow,
    MDBModalBody,
    MDBModalFooter
} from 'mdbreact';
import { MdPrint } from "react-icons/md";
import { FaRegFilePdf } from "react-icons/fa6";
import Select from 'react-select';

import { Button, CircularProgress, TextField } from '@mui/material';
import GridItem from '../../Grid/GridItem';
import { PDFDownloadLink, PDFViewer, pdf } from '@react-pdf/renderer';
import ReportPDFFile from '../../GeneratePDF/Report/';
import PedidosService from '../../../services/pedidos/pedidos';
import '../styles.css';
import GridContainer from '../../Grid/GridContainer';

const customStyles = {
    // ... (restante dos seus estilos)
    control: (provided, state) => ({
      ...provided,
      color: 'black',
      backgroundColor: 'white',
    }),
    menu: (provided, state) => ({
      ...provided,
      color: 'black',
      fontSize: '12px',
      fontWeight: '400',
      backgroundColor: '#fff',
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? 'white' : 'black',
      backgroundColor: state.isSelected ? '#000' : '#fff',
      '&:hover': {
        backgroundColor: '#f1f1f1',
        fontSize: '12px',
        fontWeight: '400'
      },
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#B19B80',
      color: '#fff',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: 'white',
      fontSize: '12px',
      fontWeight: '400'
    }),
};

export default function ReportOrderPrint() {
    const pedidosService = new PedidosService();

    const [error, setError] = useState('');
    const [pedidos, setPedidos] = useState([]);
    const [modalReportViewPDF, setReportViewPDF] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [pdfDocument, setPdfDocument] = useState(null);

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const optionsStatus = [
        { value: '0', label: 'Orçamento' },
        { value: '7', label: 'Aguardando Informações' },
        { value: '2', label: 'Aguardando envio' },
        { value: '3', label: 'Em processamento' },
        { value: '5', label: 'Finalizado' },
        { value: '6', label: 'Cancelado' },
    ];
    
    const [selectedStatusPedido, setSelectedStatusPedido] = useState([]);
    const handleChangeStatusPedido = (e, option) => {
        if (option.removedValue && option.removedValue.isFixed) return;        
        setSelectedStatusPedido(e);
    }
    const toggleReportViewPDF = () => { 
        setReportViewPDF(!modalReportViewPDF);
    }

    // Função auxiliar para formatar a data
    const formatarData = (data) => {
        if (!data) return '';
        const [ano, mes, dia] = data.split('-');
        return `${dia}-${mes}-${ano}`;
    };

    const GetPedidosForReport = () => {
        document.getElementById('viewer-document').style.display = '';
        const selectedValues = selectedStatusPedido.map(option => option.value);
        const queryString = selectedValues.join(',');
        pedidosService.getAll(startDate, endDate, queryString)
        .then(response => {
            if (response.status === 200) {
                setPedidos(response.data);
                setLoaded(true);
            } else {
                setError('Erro ao listar pedidos!');
            }
        })
        .catch(error => {
            console.log(error);
            setError('Erro ao buscar pedidos!');
        });
    }

    useEffect(() => {
        if (loaded && !pdfDocument) {
            const generatePdf = async () => {
                const doc = <ReportPDFFile pedidos={pedidos} />;
                const asPdf = pdf([]);
                asPdf.updateContainer(doc);
                const blob = await asPdf.toBlob();
                setPdfDocument(blob);
            };

            generatePdf();
        }
    }, [loaded, pedidos, pdfDocument]);

    return (
        <div>   
            <MDBModal
                isOpen={modalReportViewPDF}
                size="lg"
                toggle={toggleReportViewPDF}
                disableBackdrop
            >   
                <MDBRow center style={{display: 'flex', flexDirection: 'column', width: '100%'}}>

                    <GridItem center 
                        className="title-subinfo"
                        style={{ 
                            backgroundColor: '#ADC5B4', 
                            color: 'white', 
                            fontSize: '22px', 
                            marginLeft: '0', 
                            marginRight: '0', 
                            fontWeight: '600', 
                            marginBottom: '10px',
                            marginTop: '10px',
                            height: '35px',
                            width: '95%',
                            marginLeft: '5%',
                        }}>
                        Relatório de Pedidos
                    </GridItem>
                    <MDBModalBody>
                        <GridContainer>
                            <GridItem style={{ marginLeft: '20px' }}>
                                <TextField
                                    label="Data Inicial"
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </GridItem>
                            <GridItem style={{ marginBottom: '20px' }}>
                                <TextField
                                    label="Data Final"
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{ marginLeft: '20px' }}
                                />
                            </GridItem>
                            <GridItem style={{ marginBottom: '20px' }}>
                                <Select 
                                    isMulti
                                    style={{ marginLeft: '20px', width: '20%' }}
                                    styles={customStyles}
                                    value={selectedStatusPedido}
                                    onChange={(e, option) => {
                                        handleChangeStatusPedido(e, option)
                                    }}
                                    options={optionsStatus}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                />
                            </GridItem>
                            <GridItem style={{ marginBottom: '20px' }}>
                                <Button variant="contained" onClick={GetPedidosForReport} style={{ marginLeft: '20px' }}>
                                    Filtrar Pedidos
                                </Button>
                            </GridItem>
                     
                        </GridContainer>
                        <GridItem id='viewer-document' style={{display: 'none'}}>
                        {loaded && pdfDocument ? (
                            <PDFViewer width={700} height={600} showToolbar={false}>
                                <ReportPDFFile pedidos={pedidos} />
                            </PDFViewer>
                        ) : (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                                <CircularProgress color="primary" />
                            </div>
                        )}
                        </GridItem>
                        
                    </MDBModalBody>
                    <MDBRow end style={{marginRight: '0px'}}>
                        <MDBModalFooter>
                            {loaded ? (
                            <PDFDownloadLink
                                document={<ReportPDFFile pedidos={pedidos} />}
                                fileName={`relatorio_pedidos_${formatarData(startDate)}_a_${formatarData(endDate)}.pdf`}
                            >
                                {({ loading }) =>
                                    loading ? 
                                    <CircularProgress color="inherit" size={20} /> : 
                                    (<Button 
                                        style={{ backgroundColor: '#F6EDD2', color: '#B19B80', fontSize: '12px'}}
                                        variant="contained"
                                    >
                                        <MdPrint style={{ height: '25px', width: '40px', paddingLeft: '0px' }} />
                                    </Button>
                                    )
                                }
                            </PDFDownloadLink>
                            ):(null)}
                        </MDBModalFooter>                       

                        <MDBModalFooter>
                            <Button variant="contained" style={{backgroundColor: 'orangered'}} onClick={toggleReportViewPDF}>Fechar</Button>
                        </MDBModalFooter>
                    </MDBRow>
                </MDBRow>
            </MDBModal>
             
            <FaRegFilePdf 
                title='Relatório de Pedidos'
                className="btn-manage"
                onClick={() => {
                    toggleReportViewPDF();
                }}
                style={{ height: '20px', color: '#F6EDD2', width: '20px', marginLeft: '20px'}}
            />
        </div>
    )
}